/**
 * Created by pc on 2018/12/26.
 */

import { get } from '@/manager/http/index';
import Page from '@/global/util/Page';
const ADVERTISER_QUATYPE_MENU = 'ACCOUNT_QUATYPE_MENU'; // 资质类型下拉菜单
const ADVERTISER_INDUSTRY_MENU = 'ACCOUNT_INDUSTRY_MENU'; // 行业类型下拉菜单
const ADVERTISER_AD_TYPE_MENU = 'ADVERTISER_AD_TYPE_MENU'; // 广告主筛选类型
const ADVERTISER_TABLE_DATA = 'ADVERTISER_TABLE_DATA'; // 广告主列表
const ADVERTISER_TYPE_MENU = 'ADVERTISER_TYPE_MENU'; // 广告主类型选项
const ADVERTISER_STATUS_MENU = 'ADVERTISER_STATUS_MENU'; // 广告主状态类型
const ADVERTISER_USER_MENU = 'ADVERTISER_USER_MENU'; // 关联角色列表
const ADVERTISER_CIYTALL_MENU = 'ADVERTISER_CIYTALL_MENU'; // 城市下拉菜单
const state = {
  advertiser: {
    quaTypeMenu: [],
    curQuaType: '',
    industryMenu: [],
    cityArr: [{ name: {} }],
    adTypeMenu: [],
    advertiserTypeMenu: [],
    curAdType: '',
    auditMenu: [],
    statusMenu: [],
    userMenu: [],
    total: [],
    page: new Page()
  }
};

const getters = {
  advertiser: state => state.advertiser
};

const actions = {
  getQualificationType ({ state, commit }) {
    get('/interface/etcd/item/' + 'qua_type').then(data => {
      if (data.code === 1) {
        commit(ADVERTISER_QUATYPE_MENU, data.data);
      }
    });
  },
  getIndustryType ({ state, commit }) {
    get('/interface/etcd/item/' + 'industry').then(data => {
      if (data.code === 1) {
        commit(ADVERTISER_INDUSTRY_MENU, data.data);
      }
    });
  },
  getAdvertiserType ({ state, commit }) {
    get('/admin/advertiser/adverttype').then(data => {
      if (data.code === 1) {
        commit(ADVERTISER_TYPE_MENU, data.data);
      }
    });
  },
  getStatusMenu ({ state, commit }) {
    get('/interface/etcd/item/' + 'status').then(data => {
      if (data.code === 1) {
        commit(ADVERTISER_STATUS_MENU, data.data);
      }
    });
  },
  getUserMenu ({ state, commit }) {
    get('/admin/role/kaList').then(data => {
      if (data.code === 1) {
        commit(ADVERTISER_USER_MENU, data.data);
      }
    });
  },
  async getAdType ({ state, commit }) {
    await get('/admin/advertiser/selectlist').then(data => {
      if (data.code === 1) {
        commit(ADVERTISER_AD_TYPE_MENU, data.data);
      }
    });
  },
  async adverNameIsRepeat ({ state, commit }, { data }) {
    let response = await get('/admin/advertiser/is-repeated/' + data)
    return response
  },
  getAdvertiserTable (
    { commit, state },
    {
      pageSize = state.advertiser.page.pageSize,
      currentPage = state.advertiser.page.currentPage,
      key,
      search,
      verify
    } = {}
  ) {
    let params = {};
    params.page = currentPage;
    params.per_page = pageSize;
    params[key] = search;
    get('/admin/advertiser', params).then(res => {
      if (res.code === 1) {
        commit(ADVERTISER_TABLE_DATA, res.data);
      }
    });
  }
};

const mutations = {
  [ADVERTISER_QUATYPE_MENU] (state, data) {
    state.advertiser.quaTypeMenu = data;
  },
  [ADVERTISER_INDUSTRY_MENU] (state, data) {
    state.advertiser.industryMenu = data;
  },
  [ADVERTISER_TYPE_MENU] (state, data) {
    let dataArr = data.filter(res => {
      if (res.value === '2') {
        return false;
      } else {
        return res;
      }
    });
    state.advertiser.advertiserTypeMenu = dataArr;
  },
  [ADVERTISER_CIYTALL_MENU] (state, data) {
    state.advertiser.cityArr = data;
  },
  [ADVERTISER_STATUS_MENU] (state, data) {
    state.advertiser.statusMenu = data;
  },
  [ADVERTISER_USER_MENU] (state, data) {
    state.advertiser.userMenu = data;
  },
  [ADVERTISER_AD_TYPE_MENU] (state, data) {
    state.advertiser.adTypeMenu = data;
    state.advertiser.curAdType = data.length > 0 ? data[0].value : '';
  },
  [ADVERTISER_TABLE_DATA] (state, data) {
    state.advertiser.total = data.data.total;
    state.advertiser.page.setPageData(
      {
        header: data.header,
        data: data.data.data,
        total: data.data.total
      },
      false
    );
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
